module.exports = __webpack_public_path__ + "img/8.b82cd6e8.png";